export const HOME_NEW_JERSEY_LICENSES_STRINGS = {
  title: "Let's comply with {stateName}'s rental\u00a0codes.",
  subtitle:
    'Homes built before 1978 are required to obtain a Lead\u2011Safe Certification to confirm the property meets lead safety standards. The certification must be renewed every 3 years to\u00a0remain\u00a0valid.',
  lead_safe_label: 'I have a current Lead\u2011Safe\u00a0Certification.',
  lead_safe_sublabel: '(Less Than 3 Years Old)',
  lead_free_label: 'I have a Lead\u2011Free\u00a0Certificate.',
  no_valid_label: 'I do not have a valid lead\u00a0certification.',
  lead_safe_file_upload_label: 'Lead\u2011Safe Certificate',
  lead_free_heading: "Upload your certificate and we'll keep it on\u00a0file.",
  lead_free_description:
    'A Lead\u2011Free Certificate means your home is permanently exempt from lead\u00a0inspections.',
  lead_free_file_upload_label: 'Lead\u2011Free Certificate',
  date_issued_placeholder: 'Date Issued',
  no_valid_warning:
    "A current Lead\u2011Safe or Lead\u2011Free Certificate is needed in order to sign a Lease. \n We'll schedule a certified Pro to do the inspection and obtain the proper certification.",
  lead_safe_valid_message:
    "Excellent! Your certification is current and valid. We'll remind you when it's time to renew.",
};
